export default {
  selectedButtonBackground: 'var(--digi-blue-400)',
  selectedButtonColor: 'var(--white)',
  nonSelectedBackgroundColor: 'var(--sg-grey-200)',
  nonSelectedColor: 'var(--digi-blue-700)',
  toggleTabletLayout: 'repeat(1, 1fr)',
  labelWidth: '100%',
  buttonGroupFontWeight: '600',
};
